import _ from 'lodash';
import { roleObjKey as P, userRoleFunc, wardMenuE } from './userRole';

const roleFunctionId = {
  eHandover: 12,
  eHandover_create_note: 13,
  eHandover_pin_note: 15,
  eHandover_delete_note: 16,
  eHandover_export: 56,
  eHandover_setting: 70,

  bedStatus: 7,
  bedStatus_update_bed_status: 8,
  bedStatus_create_internal_booking: 9,
  bedStatus_manage_internal_booking: 10,
  bedStatus_edit_bed_status_module_setting: 11,

  dutyAssign: 1,
  dutyAssign_Update_Save_Publish_Notify: 2,
  dutyAssign_Custumize: 3,
  dutyAssign_Reileving_Planning: 4,
  dutyAssign_Edit_Clock_Time: 5,
  dutyAssign_Edit_Attandence_Setting: 6,
  dutyAssign_Edit_Staff_Custom_Work_Hour: 20001,
  dutyAssign_Upload_From_Excel: 20002,
  dutyAssign_Edit_Role_Duty_Detail: 20003,
  dutyAssign_Enable_Smart_Communication:20004,
  setting: 17,
  // setting user
  setting_create_manage_hospital_administrator_for_user_s_own_hospital: 19,
  setting_create_manage_hospital_administrator_for_all_hospitals: 18,
  setting_create_manage_ward_iC_for_all_wards: 20,
  setting_create_manage_ward_iC_for_user_s_own_ward: 21,
  setting_create_manage_nurse_clerk_supporting_staff_for_all_wards: 22,
  setting_create_manage_nurse_clerk_supporting_staff_for_user_s_own_ward: 23,
  setting_create_manage_grant_pro_admin_for_all_hospital: 66,
  setting_create_manage_grant_pro_admin_for_own_hospital: 67,

  // setting ward
  setting_create_wards: 25,
  setting_manage_all_wards: 26,
  setting_manage_user_s_own_ward: 27,

  // setting role
  setting_manage_role_function: 24,

  // setting mapping
  setting_database_mapping: 30,
  setting_manage_lis: 42,
  setting_ADS_location: 57,

  // notification
  notification: 10001,
  not_notification: 10002,
  notification_top_notificationt: 28,
  notification_publish_notification: 29,
  notification_forward: 34,

  // setting Equipment
  setting_setup_equipment_names_and_its_default_central_stroe_of_a_hospital: 39,

  // Ward Equipment
  wardEquipment: 35,
  equipment_create_Loan_Request_Requestor_Provider_ward: 37,
  // equipment_view_inbound_loan_request_list_Requestor_ward: 39,
  // equipment_view_outbound_loan_request_list_Provider_ward: 40,
  equipment_export_and_Reports: 41,
  equipment_manage_Equipment_of_own_ward_create_update: 36,
  equipment_update_equipment_status_requestor_ward_owner_ward: 40,
  equipment_alarm_off: 43,

  // TeleVisit
  teleVisit_view: 53,
  teleVisit_create_new_booling: 54,
  teleVisit_Service_Support_update_booking_status: 30001,

  // setting TeleVisit
  setting_televisit_robot_service_hours_mapping: 49,
  setting_televisit_manage_robot_register_update: 50,
  setting_televisit_create_update_service_hours: 51,
  setting_televisit_setup_patient_quota: 52,
  setting_televisit_mapping_save_btn: 55,

  // setting Hospital
  setting_mangae_hospital: 45,
  setting_mangae_hospital_tag: 46,
  setting_mangae_ward_tag: 47,

  // setting admission
  setting_view_admission: 58,
  // ward drive
  not_ward_drive: 10003,

  // logout control
  logout_control: 10004,

  // ha chatroom
  setting_mangage_ward_chatroom: 20000,
  setting_mangage_ward_chatCategory: 20010,

  // patient survey
  patient_survey: 59,
  view_and_share_all_wards_appreciation: 60,
  share_appreciation: 62,
  view_presonal_contact_of_appreciation: 63,
  export_all_appreciation: 64,
  gen_appreciation_qr_code: 65,
  edit_appreciation: 10007,
  // setting bedstatus
  setting_view_bedstatus: 68,
};

const authNameE = {
  home: 1,
  notification: 51,
  notification_top_notificationt: 52,
  notification_publish_notification: 53,
  notification_forward: 54,
  eHandover: 101,
  eHandover_create_note: 102,
  eHandover_pin_note: 104,
  eHandover_delete_note: 105,
  eHandover_export: 106,
  eHandover_setting: 107,
  bedStatus: 201,
  bedStatus_update_bed_status: 202,
  bedStatus_create_internal_booking: 203,
  bedStatus_manage_internal_booking: 204,
  bedStatus_edit_bed_status_module_setting: 205,
  dutyAssign: 301,
  dutyAssign_Update_Save_Publish_Notify: 302,
  dutyAssign_Custumize: 303,
  dutyAssign_Reileving_Planning: 304,
  dutyAssign_Edit_Clock_Time: 305,
  dutyAssign_Edit_Attandence_Setting: 306,
  dutyAssign_Edit_Staff_Custom_Work_Hour: 307,
  dutyAssign_Upload_From_Excel: 308,
  dutyAssign_Edit_Role_Duty_Detail: 309,
  dutyAssign_Enable_Smart_Communication:310,
  setting: 401,
  setting_view_ward: 402,
  setting_create_ward: 403,
  setting_manage_ward: 404,
  setting_view_role: 405,
  setting_create_role: 406,
  setting_manage_role: 407,
  setting_view_user: 408,
  setting_create_user: 409,
  setting_manage_user: 410,
  setting_view_databaseMapping: 411,
  setting_create_databaseMapping: 412,
  setting_manage_databaseMapping: 413,
  setting_view_equipment: 414,
  setting_manage_lis: 415,
  setting_view_TeleVisit: 416,
  setting_televisit_robot_service_hours_mapping: 417,
  setting_televisit_manage_robot_register_update: 418,
  setting_televisit_create_update_service_hours: 419,
  setting_televisit_setup_patient_quota: 420,
  setting_televisit_mapping_save_btn: 421,
  setting_view_Hospital: 430,
  setting_view_Hospital_Tag: 431,
  setting_view_Ward_Tag: 432,
  setting_ADS_location: 433,
  setting_view_admission: 434,
  setting_view_Ward_Chatroom_Setup: 435,
  setting_view_bedstatus: 437,
  setting_view_Ward_ChatCategory: 436,
  equipment: 501,
  equipment_create_Loan_Request_Requestor_Provider_ward: 502,
  equipment_view_inbound_loan_request_list_Requestor_ward: 503,
  equipment_view_outbound_loan_request_list_Provider_ward: 504,
  equipment_export_and_Reports: 505,
  equipment_manage_Equipment: 506,
  equipment_manage_Equipment_of_own_ward_create_update: 507,
  equipment_update_equipment_status_requestor_ward_owner_ward: 508,
  equipment_alarm_off: 509,
  wardDrive: 601,
  televisit: 602,
  teleVisit_view: 603,
  teleVisit_create_new_booling: 604,
  teleVisit_Service_Support_update_booking_status: 605,
  admission: 701,
  logout_control: 10004,
  patient_survey: 801,
  view_and_share_all_wards_appreciation: 802,
  share_appreciation: 803,
  view_presonal_contact_of_appreciation: 804,
  export_all_appreciation: 805,
  gen_appreciation_qr_code: 806,
  edit_appreciation: 807
};

const getLoginRoleMap = (roleObj, wardId) => {
  const roleIdObj = rewriteRoleFunctionId(userRoleFunc.getRoleFunc(roleObj));
  const roleMenuObj = userRoleFunc.getWardMenus(roleObj, wardId);
  const isLoginIn = (roleObj?.userId ?? undefined) !== undefined;
  const E = authNameE;

  const checkRole = (funcId, menuKey) => (isLoginIn ? roleIdObj[funcId] && roleMenuObj[menuKey] : roleMenuObj[menuKey]);
  const result = {
    [E.home]: true,
    // notification
    [E.notification]: !roleIdObj[roleFunctionId.not_notification],
    [E.notification_top_notificationt]: roleIdObj[roleFunctionId.notification_top_notificationt],
    [E.notification_publish_notification]: roleIdObj[roleFunctionId.notification_publish_notification],
    [E.notification_forward]: roleIdObj[roleFunctionId.notification_forward],
    // [E.eHandover]: roleIdObj[roleFunctionId.eHandover],
    // [E.bedStatus]: roleIdObj[roleFunctionId.bedStatus],
    // [E.dutyAssign]: roleIdObj[roleFunctionId.dutyAssign],
    [E.eHandover]: checkRole(roleFunctionId.eHandover, wardMenuE.ehandOverYn),
    [E.eHandover_create_note]: roleIdObj[roleFunctionId.eHandover_create_note],
    [E.eHandover_pin_note]: roleIdObj[roleFunctionId.eHandover_pin_note],
    [E.eHandover_delete_note]: roleIdObj[roleFunctionId.eHandover_delete_note],
    [E.eHandover_export]: roleIdObj[roleFunctionId.eHandover_export],
    [E.eHandover_setting]: roleIdObj[roleFunctionId.eHandover_setting],

    [E.bedStatus]: checkRole(roleFunctionId.bedStatus, wardMenuE.bedStatusYn),
    [E.bedStatus_update_bed_status]: roleIdObj[roleFunctionId.bedStatus_update_bed_status],
    [E.bedStatus_create_internal_booking]: roleIdObj[roleFunctionId.bedStatus_create_internal_booking],
    [E.bedStatus_manage_internal_booking]: roleIdObj[roleFunctionId.bedStatus_manage_internal_booking],
    [E.bedStatus_edit_bed_status_module_setting]: roleIdObj[roleFunctionId.bedStatus_edit_bed_status_module_setting],

    [E.dutyAssign]: checkRole(roleFunctionId.dutyAssign, wardMenuE.dutyAssignYn),
    [E.dutyAssign_Update_Save_Publish_Notify]: roleIdObj[roleFunctionId.dutyAssign_Update_Save_Publish_Notify],
    [E.dutyAssign_Custumize]: roleIdObj[roleFunctionId.dutyAssign_Custumize],
    [E.dutyAssign_Reileving_Planning]: roleIdObj[roleFunctionId.dutyAssign_Reileving_Planning],
    [E.dutyAssign_Edit_Clock_Time]: roleIdObj[roleFunctionId.dutyAssign_Edit_Clock_Time],
    [E.dutyAssign_Edit_Attandence_Setting]: roleIdObj[roleFunctionId.dutyAssign_Edit_Attandence_Setting],
    [E.dutyAssign_Edit_Staff_Custom_Work_Hour]: roleIdObj[roleFunctionId.dutyAssign_Edit_Staff_Custom_Work_Hour],
    [E.dutyAssign_Upload_From_Excel]: roleIdObj[roleFunctionId.dutyAssign_Upload_From_Excel],
    [E.dutyAssign_Edit_Role_Duty_Detail]: roleIdObj[roleFunctionId.dutyAssign_Edit_Role_Duty_Detail],
    [E.dutyAssign_Enable_Smart_Communication]: roleIdObj[roleFunctionId.dutyAssign_Enable_Smart_Communication],
    
    [E.setting]: true,
    // setting ward
    [E.setting_view_ward]:
      roleIdObj[roleFunctionId.setting_create_wards] ||
      roleIdObj[roleFunctionId.setting_manage_all_wards] ||
      roleIdObj[roleFunctionId.setting_manage_user_s_own_ward],
    [E.setting_create_ward]: roleIdObj[roleFunctionId.setting_create_wards],
    [E.setting_manage_ward]:
      roleIdObj[roleFunctionId.setting_manage_all_wards] || roleIdObj[roleFunctionId.setting_manage_user_s_own_ward],
    // setting role
    [E.setting_view_role]: roleIdObj[roleFunctionId.setting_manage_role_function],
    [E.setting_create_role]: false,
    [E.setting_manage_role]: roleIdObj[roleFunctionId.setting_manage_role_function],
    // setting user
    [E.setting_view_user]:
      roleIdObj[roleFunctionId.setting_create_manage_ward_iC_for_all_wards] ||
      roleIdObj[roleFunctionId.setting_create_manage_hospital_administrator_for_user_s_own_hospital] ||
      roleIdObj[roleFunctionId.setting_create_manage_hospital_administrator_for_all_hospitals] ||
      roleIdObj[roleFunctionId.setting_create_manage_ward_iC_for_user_s_own_ward] ||
      roleIdObj[roleFunctionId.setting_create_manage_nurse_clerk_supporting_staff_for_all_wards] ||
      roleIdObj[roleFunctionId.setting_create_manage_nurse_clerk_supporting_staff_for_user_s_own_ward] ||
      roleIdObj[roleFunctionId.setting_create_manage_grant_pro_admin_for_all_hospital] ||
      roleIdObj[roleFunctionId.setting_create_manage_grant_pro_admin_for_own_hospital],
    [E.setting_create_user]:
      roleIdObj[roleFunctionId.setting_create_manage_ward_iC_for_all_wards] ||
      roleIdObj[roleFunctionId.setting_create_manage_hospital_administrator_for_user_s_own_hospital] ||
      roleIdObj[roleFunctionId.setting_create_manage_hospital_administrator_for_all_hospitals] ||
      roleIdObj[roleFunctionId.setting_create_manage_ward_iC_for_user_s_own_ward] ||
      roleIdObj[roleFunctionId.setting_create_manage_nurse_clerk_supporting_staff_for_all_wards] ||
      roleIdObj[roleFunctionId.setting_create_manage_nurse_clerk_supporting_staff_for_user_s_own_ward],
    [E.setting_manage_user]:
      roleIdObj[roleFunctionId.setting_create_manage_ward_iC_for_all_wards] ||
      roleIdObj[roleFunctionId.setting_create_manage_hospital_administrator_for_user_s_own_hospital] ||
      roleIdObj[roleFunctionId.setting_create_manage_hospital_administrator_for_all_hospitals] ||
      roleIdObj[roleFunctionId.setting_create_manage_ward_iC_for_user_s_own_ward] ||
      roleIdObj[roleFunctionId.setting_create_manage_nurse_clerk_supporting_staff_for_all_wards] ||
      roleIdObj[roleFunctionId.setting_create_manage_nurse_clerk_supporting_staff_for_user_s_own_ward],
    // setting database mapping
    [E.setting_view_databaseMapping]: roleIdObj[roleFunctionId.setting_database_mapping],
    [E.setting_create_databaseMapping]: roleIdObj[roleFunctionId.setting_database_mapping],
    [E.setting_manage_databaseMapping]: roleIdObj[roleFunctionId.setting_database_mapping],
    [E.setting_view_equipment]:
      roleIdObj[roleFunctionId.setting_setup_equipment_names_and_its_default_central_stroe_of_a_hospital],
    [E.setting_manage_lis]: roleIdObj[roleFunctionId.setting_manage_lis],
    [E.setting_view_TeleVisit]: roleIdObj[roleFunctionId.setting_televisit_robot_service_hours_mapping],
    [E.setting_televisit_manage_robot_register_update]:
      roleIdObj[roleFunctionId.setting_televisit_manage_robot_register_update],
    [E.setting_televisit_create_update_service_hours]:
      roleIdObj[roleFunctionId.setting_televisit_create_update_service_hours],
    [E.setting_televisit_setup_patient_quota]: roleIdObj[roleFunctionId.setting_televisit_setup_patient_quota],
    [E.setting_televisit_mapping_save_btn]: roleIdObj[roleFunctionId.setting_televisit_mapping_save_btn],
    // ward Equipment
    [E.equipment]: isLoginIn
      ? roleMenuObj[wardMenuE.equipmentYn] && roleIdObj[roleFunctionId.wardEquipment]
      : roleMenuObj[wardMenuE.equipmentYn],
    [E.equipment_create_Loan_Request_Requestor_Provider_ward]:
      roleIdObj[roleFunctionId.equipment_create_Loan_Request_Requestor_Provider_ward],
    [E.equipment_view_inbound_loan_request_list_Requestor_ward]:
      roleIdObj[roleFunctionId.equipment_view_inbound_loan_request_list_Requestor_ward],
    [E.equipment_view_outbound_loan_request_list_Provider_ward]:
      roleIdObj[roleFunctionId.equipment_view_outbound_loan_request_list_Provider_ward],
    [E.equipment_export_and_Reports]: roleIdObj[roleFunctionId.equipment_export_and_Reports],
    [E.equipment_manage_Equipment]:
      roleIdObj[roleFunctionId.equipment_manage_Equipment_of_own_ward_create_update] ||
      roleIdObj[roleFunctionId.equipment_update_equipment_status_requestor_ward_owner_ward] ||
      roleIdObj[roleFunctionId.equipment_export_and_Reports],
    [E.equipment_manage_Equipment_of_own_ward_create_update]:
      roleIdObj[roleFunctionId.equipment_manage_Equipment_of_own_ward_create_update],
    [E.equipment_update_equipment_status_requestor_ward_owner_ward]:
      roleIdObj[roleFunctionId.equipment_update_equipment_status_requestor_ward_owner_ward],
    [E.equipment_alarm_off]: roleIdObj[roleFunctionId.equipment_alarm_off],
    // televisit
    [E.televisit]: roleMenuObj[wardMenuE.televisitYn],
    [E.teleVisit_view]: roleIdObj[roleFunctionId.teleVisit_view],
    [E.teleVisit_create_new_booling]: roleIdObj[roleFunctionId.teleVisit_create_new_booling],
    [E.teleVisit_Service_Support_update_booking_status]:
      roleIdObj[roleFunctionId.teleVisit_Service_Support_update_booking_status],

    [E.wardDrive]: roleIdObj[roleFunctionId.not_ward_drive] ? false : roleMenuObj[wardMenuE.drivePath],
    [E.setting_view_Hospital]: roleIdObj[roleFunctionId.setting_mangae_hospital],
    [E.setting_view_Hospital_Tag]: roleIdObj[roleFunctionId.setting_mangae_hospital_tag],
    [E.setting_view_Ward_Tag]: roleIdObj[roleFunctionId.setting_mangae_ward_tag],
    [E.setting_view_Ward_Chatroom_Setup]: roleIdObj[roleFunctionId.setting_mangage_ward_chatroom],
    [E.setting_view_Ward_ChatCategory]: roleIdObj[roleFunctionId.setting_mangage_ward_chatCategory],
    [E.setting_ADS_location]: roleIdObj[roleFunctionId.setting_ADS_location],
    // admission
    [E.admission]: roleMenuObj[wardMenuE.admissionYn],
    [E.setting_view_admission]: roleIdObj[roleFunctionId.setting_view_admission],

    // patient survey
    [E.patient_survey]: isLoginIn ? roleMenuObj[wardMenuE.patSurveyYn] && roleIdObj[roleFunctionId.patient_survey]: false,
    [E.view_and_share_all_wards_appreciation]: roleIdObj[roleFunctionId.view_and_share_all_wards_appreciation],
    [E.share_appreciation]: roleIdObj[roleFunctionId.share_appreciation],
    [E.view_presonal_contact_of_appreciation]: roleIdObj[roleFunctionId.view_presonal_contact_of_appreciation],
    [E.edit_appreciation]: roleIdObj[roleFunctionId.edit_appreciation],
    [E.export_all_appreciation]: roleIdObj[roleFunctionId.export_all_appreciation],
    [E.gen_appreciation_qr_code]: roleIdObj[roleFunctionId.gen_appreciation_qr_code],

    [E.logout_control]: roleIdObj[roleFunctionId.logout_control],
    [E.setting_view_bedstatus]: roleIdObj[roleFunctionId.setting_view_bedstatus],
  };
  return result;
};

const getUnloginRoleMap = (roleObj, wardId) => {
  const result = getLoginRoleMap(roleObj, wardId);
  result[authNameE.setting] = true;
  return result;
};
const rewriteRoleFunctionId = (roleList) => {
  const roleIdObj = {};
  _.forEach(Object.values(roleFunctionId), (item) => {
    roleIdObj[item] = false;
  });
  if (!roleList) return roleIdObj;
  _.forEach(roleList, (item) => {
    const functionId = item[P.functionId];
    if (roleIdObj.hasOwnProperty(functionId)) roleIdObj[functionId] = true;
  });
  return roleIdObj;
};

const roleMapFunc = {
  getExistMenuIds: (roleMap) => {
    const menuIds = [
      authNameE.home,
      authNameE.notification,
      authNameE.eHandover,
      authNameE.bedStatus,
      authNameE.dutyAssign,
      authNameE.equipment,
      authNameE.televisit,
      authNameE.wardDrive,
      authNameE.admission,
      authNameE.setting,
      authNameE.patient_survey,
    ];
    return menuIds.filter((menuId) => roleMap?.[menuId]);
  },
  getSettingTabIds: (roleMap) => {
    return Object.keys(roleMap)
      .filter((item) => {
        return item > 401 && roleMap[item];
      })
      .map((item) => {
        return Number(item);
      });
  },
};

export { authNameE, roleMapFunc, getLoginRoleMap, getUnloginRoleMap };
